// Meta Pixel ID
const PIXEL_ID = '2033544533998516'

// Extend window type for fbq
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: unknown
  }
}

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq)
    return // already initialized
    // Inject the fbq function
  ;(function (
    f: Window & typeof globalThis,
    b: Document,
    e: string,
    v: string,
  ) {
    let n: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue: unknown[]
      loaded: boolean
      version: string
      push: (...args: unknown[]) => void
    }
    if ((f as unknown as { fbq: unknown }).fbq) return
    n = function (...args: unknown[]) {
      if (n.callMethod) {
        n.callMethod(...args)
      } else {
        n.queue.push(args)
      }
    }
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    ;(f as unknown as { fbq: typeof n; _fbq: typeof n }).fbq = n
    ;(f as unknown as { _fbq: typeof n })._fbq = n
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    b.head.appendChild(t)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', {
    content_name: 'Guía Hogar Dorado',
    content_ids: ['hogar-dorado-guia'],
    content_type: 'product',
    value: 6.36,
    currency: 'USD',
  })
}
